module.exports = __webpack_public_path__ + "static/media/column1.d9aeaaa9.png";